"use strict";

//1. Initialization
import "../scss/style.scss";
import { gsap } from "gsap";
import navigation from "./modules/navigation.js";

//2. Event Area 
window.addEventListener("load", function () {
    gsap.fromTo(
        ".preloader",
        { duration:1, autoAlpha:1},
        { duration:1, autoAlpha:0}
    );
});








